export default {
  preventivi(state) {
    return state.preventivi;
  },
};
